import { useSrpContext } from '@/src/contexts'

import AirportInfo from './airportInfo'

const AirportInfoWrapper = () => {
    const {
        SEOSrpData: { sections, search }
    } = useSrpContext()

    const airports = sections?.airports
    if (!airports?.length) return null

    const codeMap: Record<string, { iata: string; city: string }> = {
        origin: { iata: search?.from ?? '', city: search?.origin ?? '' },
        destination: { iata: search?.to ?? '', city: search?.destination ?? '' }
    }

    const mapped = airports
        .map(a => {
            const resolved = codeMap[a.code]
            const code = resolved?.iata || a.code
            const name = a.name || (resolved ? `${resolved.city} (${resolved.iata})` : a.code)
            return { code, name, terminals: a.terminals, lounges: a.lounges ?? [], transportToCity: a.transportToCity }
        })
        .filter(a => a.code)

    if (mapped.length === 0) return null

    return <AirportInfo airports={mapped} />
}

export default AirportInfoWrapper
